import { createSchemaField } from '@formily/react';
import { componentMap } from "../component-map";
export var SchemaField = createSchemaField({
    components: componentMap,
});
